import React, { useState } from 'react';
import {ReactComponent as CarlenderIcon} from '../components/svgs/carlendericon.svg';
import {ReactComponent as ActiveIcon} from './svgs/activeIcon.svg'
import { Link } from 'react-router-dom';

const TabComponent = () => {
  const [activeTab, setActiveTab] = useState(0);

  const tabs = [
    {
      title: 'Past Due',
      icon: <CarlenderIcon/>,
      tableData: [
        { orderNo: '#23', customer: 'Geller Industries', commercialCustomerRep: 'Ross Geller', status: 'Washing', bags: 3, size: 119 },
        { orderNo: '#11', customer: 'Phoebe Buffay', status: 'Drying', bags: 3, size: 200 },
        { orderNo: '#16', customer: 'Tribianni & Sons Ltd.', commercialCustomerRep: 'Joey Tribianni', status: 'Folding', bags: 4, size: 145 },
        { orderNo: '#65', customer: 'Monica’s Inc', commercialCustomerRep: 'Monica’s Geller-Bing', status: 'Binned', bags: 12, size: 134 },
        { orderNo: '#108', customer: 'Chandler Bing', status: 'Folding', bags: 16, size: 119 },
        { orderNo: '#218', customer: 'Marcel Geller', status: 'Washing', bags: 0, size: 0 },
      ]
    },
    {
      title: 'Due Today',
      icon: <CarlenderIcon/>,
      tableData: [
        // Add data for Tab 2
        { orderNo: '001', customer: 'John Doe', status: 'Pending', bags: 2, size: 10, viewButton: '#' },
        { orderNo: '002', customer: 'Jane Smith', status: 'Completed', bags: 3, size: 15 },
      ]
    },
    {
      title: 'Due Tomorrow',
      icon: <CarlenderIcon/>,
      tableData: [
        // Add data for Tab 3
      ]
    }
  ];

  const handleTabClick = (index) => {
    setActiveTab(index);
  };

  return (
    <>
    <div className="tab-container">

        <div className="tab-titles">
        {tabs.map((tab, index) => (
            <div
            key={index}
            className={`tab-title ${activeTab === index ? 'active' : ''}`}
            onClick={() => handleTabClick(index)}
            >
            <div className={`tab-icon ${activeTab === index ? 'active' : ''}`}>
                {React.cloneElement(tab.icon, {
                className: activeTab === index ? 'active-icon' : ''
                })}
            </div>
            <div className={`tab-label ${activeTab === index ? 'active' : ''}`}>{tab.title}</div>
            </div>
        ))}
        </div>


      <div className="tab-content">
        {tabs.map((tab, index) => (
          <div key={index} className={`tab-pane ${activeTab === index ? 'active' : ''}`}>
            <table className="custom-table">

              <thead>
                <tr className='table-head'>
                  <th className=''>
                    Order No.
                    <span className="filter-icon">
                      <ActiveIcon />
                      
                    </span>
                  </th>
                  <th className=''>
                    Customer
                    <span className="filter-icon">
                    <ActiveIcon className=''/>
                    </span>
                  </th>
                  <th>
                    Status
                    <span className="filter-icon">
                    <ActiveIcon />
                    </span>
                  </th>
                  <th>
                    No of Bags
                    <span className="filter-icon">
                      <ActiveIcon />
                    </span>
                  </th>
                  <th>
                    Size (in pounds)
                    <span className="filter-icon">
                    </span>
                  </th>
                </tr>
              </thead>

              <tbody className='table-body'>
                {tab.tableData.map((data, dataIndex) => (
                  <tr key={dataIndex} className='table-row'>
                    <td className='table-data-1'>
                      {data.orderNo}
                      
                    </td>
                   
                    <td className='table-data-1'>
                      {data.customer}
                      <div className='customer-rep'>{data.commercialCustomerRep}</div>
                    </td>
                   
                    <td className='table-data'>
                      {data.status}
                    
                    </td>
                    <td className='table-data'>
                      {data.bags}
                    
                    </td>
                    <td className='table-data'>
                      {data.size}
                   
                    </td>
                    <td>
                        <Link to={data.viewButton} className='view-btn'>View</Link>
                    </td>
                    
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ))}
      </div>
    </div>
    </>
  );
};

export default TabComponent;
